import validator from 'validator'

export const mobilePhoneLocale: validator.MobilePhoneLocale[] = [
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'be-BY',
    'bg-BG',
    'bn-BD',
    'cs-CZ',
    'da-DK',
    'de-DE',
    'de-AT',
    'el-GR',
    'en-AU',
    'en-GB',
    'en-GG',
    'en-GH',
    'en-HK',
    'en-IE',
    'en-IN',
    'en-KE',
    'en-MT',
    'en-MU',
    'en-NG',
    'en-NZ',
    'en-PK',
    'en-RW',
    'en-SG',
    'en-TZ',
    'en-UG',
    'en-US',
    'en-ZA',
    'en-ZM',
    'es-CL',
    'es-ES',
    'es-MX',
    'es-PA',
    'es-PY',
    'es-UY',
    'et-EE',
    'fa-IR',
    'fi-FI',
    'fj-FJ',
    'fo-FO',
    'fr-FR',
    'fr-GF',
    'fr-GP',
    'fr-MQ',
    'fr-RE',
    'he-IL',
    'hu-HU',
    'id-ID',
    'it-IT',
    'ja-JP',
    'kk-KZ',
    'kl-GL',
    'ko-KR',
    'lt-LT',
    'ms-MY',
    'nb-NO',
    'nl-BE',
    'nl-NL',
    'nn-NO',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sl-SI',
    'sk-SK',
    'sr-RS',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'vi-VN',
    'zh-CN',
    'zh-TW',
    'en-CA',
    'fr-BE',
    'zh-HK',
]
